function Contact(){
return(
<section>
<h2>Contato</h2>
<div className="contact-links" style={{width: '8%', display: 'grid', gap: '0.4em',marginBottom: '0.4em',}}>
<a style={{color: 'white'}} href="https://github.com/Luanz1nn" target="_blank" rel="noopener noreferrer">GitHub</a>
<a style={{color: 'white'}} href="https://www.linkedin.com/in/luan-william-9a126b224/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
</div>
<p>Email: Luanz1nnwill@gmail.com</p>
<p>WhatsApp: (81) 9 8318-1562</p>

</section>
)
}

export default Contact
